// extracted by mini-css-extract-plugin
export default {"root":"VoteHeader_root__swbAJ","title":"VoteHeader_title__zOMdV","back":"VoteHeader_back__teZWz","info":"VoteHeader_info__t3yzS"};